import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { ChromePicker } from "react-color";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `sliders`;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
 
  const dispatch = useDispatch();


  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [state, setState] = useState(``);
  const [ordering, setOrdering] = useState(``);
  const [name, setName] = useState(``);
  const [linkTitle, setLinkTitle] = useState(``);
  const [link, setLink] = useState(``);
  const [position, setPosition] = useState(``);
  const [description, setDescription] = useState(``);
  const [isPromotion, setIsPromotion] = useState(``);
  const [image, setImage] = useState(``);
  const [mobileImage, setMobileImage] = useState(``);

  const [color, setColor] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);
  const handleChangePromotion = (value) => setIsPromotion(value);
  const handleChangePosition = (value) => setPosition(value);

  const handleChangeComplete = (color, hex) => setColor(color.hex);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.sliders_store != undefined && appReducer.sliders_store.error == false) ||
        (appReducer.sliders_update != undefined && appReducer.sliders_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.sliders_store,
    appReducer.sliders_update
  ])

  useEffect(() => {
    if (appReducer.sliders_edit != undefined && id != undefined) {

      let row = appReducer.sliders_edit.data;

      setName(row.name);

      setColor(row.color);

      setOrdering(row.ordering)

      let labelPosition = "بالا"
      if (row.position == `bottom`) {
        labelPosition = "پایین"
      }

      if (row.position == `left`) {
        labelPosition = "چپ"
      }

      if (row.position == `right`) {
        labelPosition = "راست"
      }
      setPosition({
        value: row.position,
        label: labelPosition,
      });
      setLink(row.link);
      setDescription(row.description);
      setLinkTitle(row.link_title);
      setIsPromotion({
        value: row.is_promotion,
        label: row.is_promotion == `active` ? `فعال` : `غیرفعال`,
      });
      setImage(row.image_full);
      setMobileImage(row.mobile_image_full)
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
    }
  }, [appReducer.sliders_edit]);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input value={name} label="نام" name="name" type="text" />
    <Template.Input required value={ordering} label="ترتیب نمایش" name="ordering" type="text" />
    <Template.Input value={link} label="آدرس لینک" name="link" type="text" />
    <Template.Input value={linkTitle} label="عنوان لینک" name="link_title" type="text" />
    <Template.Textarea value={description} label="توضیحات" name="description" type="text" />
    <div
      style={{
        marginBottom: "20px",
        padding: "15px 10px",
        border: `2px ${color} solid`,
      }}
    >
      <ChromePicker
        color={color ?? "#FFF"}
        onChangeComplete={handleChangeComplete}
      />
      <input type="hidden" name="color" defaultValue={color} />
    </div>

    <Template.SingleSelect
      withLabel
      required
      placeholder="نمایش در پروموشن"
      onChange={handleChangePromotion}
      name="is_promotion"
      value={isPromotion}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    {isPromotion && isPromotion.value == "active" && <Template.SingleSelect
      withLabel
      placeholder="مکان نمایش"
      onChange={handleChangePosition}
      name="position"
      value={position}
      options={[
        {
          value: "top",
          label: "بالا",
        },
        {
          value: "left",
          label: "چپ",
        },
        {
          value: "right",
          label: "راست",
        },
        {
          value: "bottom",
          label: "پایین",
        },
      ]}
    />}
    <Template.FileInput
      deleteUrl="sliders/destroy_image"
      rowId={id}
      required
      className="image"
      value={image && [image]}
      name="image"
      label="تصویر"
    />
    <Template.FileInput
      deleteUrl="sliders/destroy_mobile_image"
      rowId={id}
      required
      className="mobile_image"
      value={mobileImage && [mobileImage]}
      name="mobile_image"
      label="تصویر  موبایل"
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};